export { MonolithCartPageHeadingContainer } from './MonolithCartPageHeadingContainer';
export type { PageHeadingProps } from './PageHeading';
export { PageHeading } from './PageHeading';
